import { useState, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import moment from 'moment';

// Model //
import FetchModule from '../../../../Share/Network/FetchModule.js';
// Model //

// Component //
import UserNameChangeInput from '../../../../../Component/MemberComponent/MemberDetail/UserNameChangeInput.js';
import PhoneChangeInput from '../../../../../Component/MemberComponent/MemberDetail/PhoneInput.js';
import CalenderInput from '../../../../../Component/MemberComponent/CalenderInput.js';
// Component //

// Image //
import DefaultProfile from '../../../../../image/DefaultProfile.png'
// Image //

export default function UserNameModifyModal(props) {
  const { profile, userName, birthDay, gender, phone, onClickClose, onClickSave } = props;

  const [date, setDate] = useState(moment(birthDay).format('YYYY.MM.DD'));
  const [changedName, setChangedName] = useState(userName);
  const [changeGender, setChangeGender] = useState(gender);
  
  const [isCheckedPhone, setIsCheckedPhone] = useState(false);
  const [changePhone, setChangePhone] = useState(phone);

  const [imgBase64, setImgBase64] = useState(profile);
  const [imgFile, setImgFile] = useState('');
  // const [isUpLoad, setIsUpLoad] = useState(false);
  // const [imgLocalPath, setImgLocalPath] = useState('');
  const [isErrorProfile, setIsErrorProfile] = useState(false);

  const hiddenFileInput = useRef(null);

  // 모달 활성화 시 전체 스크롤 제어 //
  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  function handleClick() {
    hiddenFileInput.current.click();
	}
	
  function handleChange(e) { 
    let pathpoint = e.target.value.lastIndexOf('.');
    let filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    let filetype = filepoint.toLowerCase();

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      // 정상적인 이미지 확장자 파일인 경우

    } 
    else {
      alert('.jpeg .jpg .png 파일만 가능합니다!');
      let parentObj = e.target.parentNode
      let node = parentObj.replaceChild(e.target.cloneNode(true), e.target);

      return false;
    }

		const reader = new FileReader();

    // let tmp = e.target.value.split('\\');
    // setImgLocalPath(tmp[tmp.length - 1]);
    
		reader.onloadend = () => {
			const base64 = reader.result;
      
			if (base64){
				setImgBase64(base64.toString());
			}
		};

		if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
      setImgFile(e.target.files[0]);
		}
	}

  function onError() {
    setIsErrorProfile(true);
  }

  function decideUserProfile() {
    if (isErrorProfile) return DefaultProfile;
    else if (imgFile) return URL.createObjectURL(imgFile);
    else if (imgBase64 !== '') return imgBase64;
    else return DefaultProfile;
  }
  

  // Do Nothing //
  function clickFn() {}

  // 저장 버튼 클릭시 //
  function onClickSaveButton() {

    onClickSave(imgBase64, changedName, moment(date).format('YYYYMMDD'), changeGender, changePhone);
  }

  // 전화번호 확인 버튼 클릭시 //
  function onClickCheckButton() {

    if (changePhone === phone) return;
    else if (isCheckedPhone) return;
    
    if (changePhone.length < 9) {
      alert('휴대폰 번호를 정확히 입력해주세요');
      return;
    }

    let data = {
      phone: changePhone,
      userId: '',
      profile: ''
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('userInfo/detail/invalid/user', 'POST', data);
        
        if (responseData.status === 200) {
          alert('가입자 확인이 완료되었습니다');
          setChangePhone(responseData.data[0].phone);
          setIsCheckedPhone(true);
        }
        else if (responseData.status === 201) {
          alert('회원정보가 일치하지 않습니다.');
        }
        else if (responseData.status === 204) {
          alert('회원정보가 존재하지 않습니다.');
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <input type="file"
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{ display: 'none' }} />
      <ModalView>
        <TitleWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#232323' cursor='default'>회원 정보 변경</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#777777' cursor='default'>회원의 정보를 변경할 수 있습니다</Text>
        </TitleWrapper>
        <TotalWrapper>
          <ProfileBoxWrapper onClick={handleClick}>
            {
              imgBase64 !== '' ?
                <Profile src={decideUserProfile()} onError={onError} />
                :
                <ProfileBox>
                  <PlusBox>
                    <Stick width={50} height={6} />
                    <Stick width={6} height={50} />
                  </PlusBox>
                </ProfileBox>
            }
          </ProfileBoxWrapper>
          <InfoBox>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>변경할 회원 명</Text>
            <UserNameChangeInput value={changedName} setValue={setChangedName} placeholder='회원 명을 입력해 주세요'/>
          </InputWrapper>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>변경할 휴대폰 번호</Text>
            <PhoneChangeInput 
              value={changePhone} 
              setValue={setChangePhone} 
              isCheckedPhone={isCheckedPhone}
              setIsCheckedPhone={setIsCheckedPhone}
              originalPhone={phone}
              placeholder='전화번호를 입력해 주세요' 
              onClickCheck={onClickCheckButton}/>
          </InputWrapper>
          <DateInputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000'>변경할 회원 생년월일</Text>
            <CalenderInput value={date} setValue={setDate} clickFn={clickFn} width={208}/>
          </DateInputWrapper>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000'>변경할 회원 성별</Text>
            <GenderBoxWrapper>
              <GenderBox isClicked={changeGender === 'male'} onClick={() => setChangeGender('male')}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={ changeGender === 'male' ? '#FFFFFF' : '#000000'}>남성</Text>
              </GenderBox>
              <GenderBox isClicked={changeGender === 'female'} onClick={() => setChangeGender('female')}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={ changeGender === 'female' ? '#FFFFFF' : '#000000'}>여성</Text>
              </GenderBox>
            </GenderBoxWrapper>
          </InputWrapper>
          </InfoBox>
        </TotalWrapper>
        <ButtonWrapper>
          <ExitButton onClick={onClickClose}>취소</ExitButton>
          <SaveButton onClick={onClickSaveButton}>저장하기</SaveButton>
        </ButtonWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;
  
  width: 100vw;
  height: 100vh;

  overflow-y: scroll;

  background-color: rgba(0, 0, 0, 0.2);

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 576px;
  height: 478px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #FFFFFF;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 93.05%;

  gap: 8px;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  width: 93.05%;

  gap: 8px;
`;

const ProfileBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 298px;
  height 298px;

  :hover {
    cursor: pointer;
  }
`;

const ProfileBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height 100%;

  border-radius: 10px;
  background-color: #F5F6F8;
`;

const Profile = styled.img`
  width: 100%;
  height: 100%;
  
  border-radius: 10px;
  
  overflow: hidden;

  object-fit: contain;
`;

const PlusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;  
`;

const Stick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 20px;
  background-color: #969696;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 230px;

  gap: 16px;
`;

const GenderBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const GenderBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(47.61% - 2px);
  height: 30px;

  border-radius: 5px;
  border: ${props => props.isClicked ? '1px solid #FF8B48' : '1px solid #969696'};
  background-color: ${props => props.isClicked ? '#FF8B48' : '#FFFFFF'};

  :hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 12px;
`;

const DateInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 93.05%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 38px;

  border-radius: 10px;
  background-color: #F5F6F8;
  
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #6DD49E;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;